import { Component, Entity } from "excalibur";
import { DynamicResources, ProvidesResources } from "../types";

export class ResourcePerTurnComponent extends Component {
  public ore: number = 0;
  public food: number = 0;
  public fuel: number = 0;
  public fight: number = 0;
  public money: number = 0;

  constructor(
    public label: string,
    resources: ProvidesResources,
    public includeInSums: boolean,
  ) {
    super();
    Object.assign(this, resources);
  }

  get resources(): DynamicResources {
    return {
      ore: this.ore,
      food: this.food,
      fuel: this.fuel,
      fight: this.fight,
      money: this.money,
    };
  }
}

export function calculateDelta(
  entities: Entity<ResourcePerTurnComponent>[],
): DynamicResources {
  const delta: DynamicResources = {
    ore: 0,
    food: 0,
    fuel: 0,
    fight: 0,
    money: 0,
  };
  for (const entity of entities) {
    const component = entity.get(ResourcePerTurnComponent);
    if (!component.includeInSums) continue;
    if (component) {
      delta.ore += component.ore;
      delta.food += component.food;
      delta.fuel += component.fuel;
      delta.fight += component.fight;
      delta.money += component.money;
    }
  }

  return delta;
}
